import React from 'react';
import { useSelector, useDispatch } from "react-redux";
import { subscriptionWorkoutsFormAction, typeOpenSettingsFormAction } from "../../redux/rootReducer";
import { updateSubscriptionWorkoutsSagaAction } from "../../redux/sagaActions";

const SubscriptionWorkoutsForm = () => {
    const dispatch = useDispatch();
    const establishmentList = useSelector(state => state.establishmentList);
    const subscription_workouts_form = useSelector(state => state.subscription_workouts_form);

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <i className="form__close" onClick={ () => dispatch(typeOpenSettingsFormAction('')) } />
                        <div className="form__title">Количество занятий</div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Название</div>
                        <input type="text" className="input" value={ subscription_workouts_form.name }
                               onInput={ event => dispatch(subscriptionWorkoutsFormAction({
                                   ...subscription_workouts_form,
                                   name: event.target.value
                               })) }
                        />
                    </div>
                    {
                        subscription_workouts_form.unlim === '0'
                        ?
                            <div className="form__field">
                                <div className="input__caption input__caption--required">Количество занятий</div>
                                <input type="number" className="input" value={ subscription_workouts_form.count }
                                       onInput={ event => dispatch(subscriptionWorkoutsFormAction({
                                           ...subscription_workouts_form,
                                           count: event.target.value
                                       })) }
                                />
                            </div>
                        :
                            <div className="form__field">
                                <div className="input__caption input__caption--required">Количество занятий</div>
                                <div className="input input--inactive">Безлимитный</div>
                            </div>
                    }
                    <div className="form__field">
                        <div className="checkbox__wrapper" onClick={ () => {
                            dispatch(subscriptionWorkoutsFormAction({
                                ...subscription_workouts_form,
                                unlim: subscription_workouts_form.unlim === '0' ? '1' : '0'
                            }));

                        } }>
                            <div className={ `checkbox ${ subscription_workouts_form.unlim === '1' ? 'checkbox--active' : '' }` }/>
                            <div className="checkbox__caption">Безлимитный</div>
                        </div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required" style={{ marginBottom: '10px' }}>Для каких заведений</div>
                        {
                            establishmentList.map(elem => {
                                return (
                                    <div style={{ marginBottom: '10px' }} key={ elem.id }>
                                        <div className="checkbox__wrapper" onClick={ () => {
                                            // Старый массив с заведениями
                                            let est = [...subscription_workouts_form.establishments];
                                            // Ищем индекс выбранного элемента
                                            let findIndex = est.findIndex(el => el === elem.id);
                                            // Если в массиве есть выбранный элемент, удаляем его
                                            if (findIndex + 1) {
                                                est.splice(findIndex, 1);
                                            }
                                            else {
                                                est.push(elem.id);
                                            }

                                            dispatch(subscriptionWorkoutsFormAction({
                                                ...subscription_workouts_form,
                                                establishments: est
                                            }));

                                        } }>
                                            <div className={ `checkbox ${ subscription_workouts_form.establishments.includes(elem.id) ? 'checkbox--active' : '' }` }/>
                                            <div className="checkbox__caption">{ elem.name }</div>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                    <div className="form__field">
                        <div className="button"
                             onClick={ () => {
                                 dispatch(updateSubscriptionWorkoutsSagaAction({
                                     id: subscription_workouts_form.id,
                                     name: subscription_workouts_form.name,
                                     establishments: JSON.stringify(subscription_workouts_form.establishments),
                                     count: subscription_workouts_form.count,
                                     unlim: subscription_workouts_form.unlim
                                 }));
                             } }
                        >
                            Сохранить
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SubscriptionWorkoutsForm;